module.exports = __webpack_public_path__ + "static/media/logo.03d12e00.svg";